import React, { ReactNode, Suspense } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { InterruptedCashinProvider } from '@features/cashier/pages/cashin/InterruptedCashinProvider';
import { ErrorBoundary } from '@shared/components/ErrorBoundary';
import { LoadingFallback } from '@shared/components/ui/LoadingFallback';
import { lazyWithRetry } from '@shared/utils/lazyWithRetry';

const AuthRoute = lazyWithRetry(() => import('./AuthRoute.tsx').then((m) => ({ default: m.AuthRoute })));
const ProtectedRoute = lazyWithRetry(() => import('./ProtectedRoute.tsx').then((m) => ({ default: m.ProtectedRoute })));

const RouteErrorBoundary: React.FC<{ children: ReactNode }> = ({ children }) => {
  const location = useLocation();
  return <ErrorBoundary key={location.pathname}>{children}</ErrorBoundary>;
};

const Routing: React.FC = () => {
  return (
    <InterruptedCashinProvider>
      <RouteErrorBoundary>
        <Suspense fallback={<LoadingFallback />}>
          <Routes>
            <Route path="/auth/*" element={<AuthRoute />} />
            <Route path="/*" element={<ProtectedRoute />} />
          </Routes>
        </Suspense>
      </RouteErrorBoundary>
    </InterruptedCashinProvider>
  );
};

export default Routing;
